/* eslint-disable */
if (typeof window.getQueryVal == 'undefined') {
  window.getQueryVal = function (param) {
    qs = window.location.search.substring(1);
    vals = qs.split('&');
    for (i = 0; i < vals.length; i++) {
      ar = vals[i].split('=');
      if (ar[0] == param) {
        return ar[1];
      }
    }
  }
}
if (typeof window.selectPage == 'undefined') {
  window.selectPage = function (dropdown) {
    if (($('#showing-page').val() == undefined)) {
      var newPageNum = 1;
    } else {
      newPageNum = $('#showing-page').val();
    }
    const queryParams = {
      q: getQueryVal('q'),
      rid: getQueryVal('rid'),
      month: getQueryVal('month'),
      year: getQueryVal('year'),
      c: getQueryVal('c'),
      sort: getQueryVal('sort'),
      order: getQueryVal('order'),
      sponsored: getQueryVal('sponsored'),
      region: getQueryVal('region'),
      type: getQueryVal('type'),
      section: getQueryVal('section'),
      maxrows: $('#maxrows').val(),
      pagenum_rs: newPageNum,
      expanded: getQueryVal('expanded'),
    };

    let queryString = '?';
    for (const queryParam in queryParams) {
      if (queryParams[queryParam]) {
        queryString += `${ queryParam }=${ queryParams[queryParam] }&`;
      }
    }

    const newUrl = (window.location.href.split('?'))[0] + queryString.slice(0, -1);

    if (typeof transitions !== 'undefined' && newUrl) {
      transitions.go(newUrl);
    } else if (newUrl) {
      location.href = newUrl;
    }
  }
}
